
import React, {FC} from 'react';
import classNames from 'classnames';

export {Logout} from './Group/Logout';
export {Groups} from './Groups';
export {Explore, Welcome} from './Heading';
export {Browse} from './IconLinks';

import * as styles from './styles.module.scss';

type MenuNavProps = {
	className?: string
	children: React.ReactNode
}

const MenuNav: FC<MenuNavProps> = ({className, children}) => {
	return (
		<div className={classNames(styles.nav, className)}>
			{children}
		</div>
	);
};

export default MenuNav;

